import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline"

function Pagination({ nPages, currentPage, setCurrentPage, length }) {

    const pageNumbers = [...Array(nPages + 1).keys()].slice(1)

    const goToNextPage = () => {
        if (currentPage !== nPages) setCurrentPage(currentPage + 1)
    }

    const goToPrevPage = () => {
        if (currentPage !== 1) setCurrentPage(currentPage - 1)
    }

    const start = currentPage > 1 ? (currentPage - 1) * 10 + 1 : 1;
    const end = Math.min(currentPage * 10, length);

    return (
        <div className="flex items-center justify-between px-5 py-3">
            <p className="text-xs text-gray-400 dark:text-gray-500 tabular-nums">
                {nPages > 1
                    ? <>Showing <span className="font-medium text-gray-600 dark:text-gray-300">{start}–{end}</span> of <span className="font-medium text-gray-600 dark:text-gray-300">{length}</span></>
                    : <><span className="font-medium text-gray-600 dark:text-gray-300">{length}</span> result{length !== 1 ? 's' : ''}</>
                }
            </p>

            <div className="inline-flex items-center gap-1">
                <button
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                    className="inline-flex items-center justify-center h-7 w-7 rounded-md text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[.06] hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                >
                    <ChevronLeftIcon className="h-4 w-4" />
                </button>

                {pageNumbers.map(item => (
                    <button
                        key={item}
                        onClick={() => setCurrentPage(item)}
                        className={`inline-flex items-center justify-center h-7 min-w-[28px] px-2 rounded-md text-xs font-medium transition-colors ${
                            currentPage === item
                                ? 'bg-gold-600 text-white shadow-sm'
                                : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[.06]'
                        }`}
                    >
                        {item}
                    </button>
                ))}

                <button
                    onClick={goToNextPage}
                    disabled={currentPage === nPages}
                    className="inline-flex items-center justify-center h-7 w-7 rounded-md text-gray-400 hover:bg-gray-100 dark:hover:bg-white/[.06] hover:text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                >
                    <ChevronRightIcon className="h-4 w-4" />
                </button>
            </div>
        </div>
    )
}

export default Pagination
